import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

window.addEventListener('DOMContentLoaded', () => {
	const fadeUp = gsap.utils.toArray('[data-animation="fade-up"]')
	const fadeDown = gsap.utils.toArray('[data-animation="fade-down"]')
	const fadeRight = gsap.utils.toArray('[data-animation="fade-right"]')
	const fadeLeft = gsap.utils.toArray('[data-animation="fade-left"]')

	let mm = gsap.matchMedia()

	let ease = 'elastic.out(1, 1)' // Eases https://greensock.com/docs/v3/Eases
	let timing = 2 // Duration in seconds
	let distance = 200 // Distance in pixels

	mm.add('(min-width: 1200px)', () => {
		// Disables code below 1200px browser width
		fadeUp.forEach((fadeUp, i) => {
			const anim = gsap.fromTo(
				fadeUp,
				{ autoAlpha: 0, y: distance },
				{ duration: timing, autoAlpha: 1, y: 0, ease: ease }
			)

			ScrollTrigger.create({
				trigger: fadeUp,
				animation: anim,
				start: 'top 120%',
				toggleActions: 'play none none none',
				once: true,
			})
		})

		fadeDown.forEach((fadeDown, i) => {
			const anim = gsap.fromTo(
				fadeDown,
				{ autoAlpha: 0, y: -distance },
				{ duration: timing, autoAlpha: 1, y: 0, ease: ease }
			)

			ScrollTrigger.create({
				trigger: fadeDown,
				animation: anim,
				toggleActions: 'play none none none',
				once: true,
			})
		})

		fadeLeft.forEach((fadeLeft, i) => {
			const anim = gsap.fromTo(
				fadeLeft,
				{ autoAlpha: 0, x: distance },
				{ duration: timing, autoAlpha: 1, x: 0, ease: ease }
			)

			ScrollTrigger.create({
				trigger: fadeLeft,
				animation: anim,
				toggleActions: 'play none none none',
				once: true,
			})
		})

		fadeRight.forEach((fadeRight, i) => {
			const anim = gsap.fromTo(
				fadeRight,
				{ autoAlpha: 0, x: -distance },
				{ duration: timing, autoAlpha: 1, x: 0, ease: ease }
			)

			ScrollTrigger.create({
				trigger: fadeRight,
				animation: anim,
				toggleActions: 'play none none none',
				once: true,
			})
		})
	})
})
